<div class="table-header pb-3 px-4">
    <div class="header-content">
        <h2 class="table-title">{{ 'app.users.dashboard.all_users_title' | translate }}</h2>
        <button mat-icon-button (click)="facade.reload()"
            class="d-flex align-items-center justify-content-center focus-outline-none"
            [matTooltip]="'shared.general.tooltips.refresh' | translate" [disabled]="facade.isLoading()">
            <mat-icon>refresh</mat-icon>
        </button>
    </div>
    @if (facade.count() !== null) {
    <div class="count-line">
        <span class="count-badge">{{ facade.count() }}</span>
        <span class="count-label">{{ 'app.users.dashboard.users_found_suffix' | translate }}</span>
    </div>
    }
</div>
<div class="table-wrapper" #tableWrapper>
    <!-- Table -->
    <table mat-table [dataSource]="dataSource()" matSort (matSortChange)="onSortChange($event)">

        <!-- Index Column -->
        <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.users.table.columns.index' | translate }}</th>
            <td mat-cell *matCellDef="let row; let i = index">{{i + 1}}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="name">{{ 'app.users.table.columns.name' |
                translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.displayUserName() | translate }}</td>
        </ng-container>

        <!-- Phone Column -->
        <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.users.table.columns.phone' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.displayPhone() | translate }}</td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="email">{{ 'app.users.table.columns.email' |
                translate }}</th>
            <td mat-cell *matCellDef="let row">
                <app-table-copy-cell [content]="row.displayEmail() | translate"
                    [tooltipText]="'app.users.table.columns.email' | translate">
                </app-table-copy-cell>
            </td>
        </ng-container>

        <!-- Job Title Column -->
        <ng-container matColumnDef="jobTitle">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.users.table.columns.job_title' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.displayJobTitle() | translate }}</td>
        </ng-container>

        <!-- Department Column -->
        <ng-container matColumnDef="department">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.users.table.columns.department' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.displayDepartment() | translate }}</td>
        </ng-container>

        <!-- Mobile Phone Column -->
        <ng-container matColumnDef="mobilePhone">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.users.table.columns.mobile_phone' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.displayMobilePhone() | translate }}</td>
        </ng-container>

        <!-- Employee ID Column -->
        <ng-container matColumnDef="employeeId">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.users.table.columns.employee_id' | translate }}</th>
            <td mat-cell *matCellDef="let row">
                <app-table-copy-cell [content]="row.displayEmployeeId() | translate"
                    [tooltipText]="'app.users.table.columns.employee_id' | translate">
                </app-table-copy-cell>
            </td>
        </ng-container>

        <!-- Action/Status Column -->
        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.users.table.columns.action' | translate }}</th>
            <td mat-cell *matCellDef="let row">
                <a [routerLink]="['/users/', row.routeId()]" [style.color]="'var(--avyna-color-primary)'">
                    {{ 'app.users.table.actions.view_details' | translate }}
                </a>
            </td>
        </ng-container>

        <!-- Header Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

        <!-- Data Row -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
    <!-- No Data Row -->
    @if(dataSource().data.length === 0){
    <div class="no-data-content mt-5 pt-5">
        @if(facade.isLoading()){
        <mat-spinner diameter="40"></mat-spinner>
        <span>{{ 'app.users.table.loading' | translate }}</span>
        }@else{
        <span>{{ 'app.users.table.no_data' | translate }}</span>
        }
    </div>
    }

    <!-- Loading Bar -->
    <app-table-loading-bar [isLoading]="facade.isLoading()"></app-table-loading-bar>

    <div class="bottom-detector" #bottomDetector></div>

</div>

<div class="load-more-container">
    @if(!facade.isLoadingMore()){
    <button mat-flat-button class="load-more-btn d-flex"
        [class.visible]="facade.hasMore() && isBottomReached() && !facade.isLoading()" (click)="facade.loadMore()"
        [disabled]="facade.isLoadingMore()">
        <span>{{ 'app.users.table.load_more' | translate }}</span>
    </button>
    }@else{
    <mat-spinner class="mx-auto" diameter="40" strokeWidth="5"></mat-spinner>
    }
</div>